import TransactionAppDelegate from './delegate';
import { computed, makeObservable, toJS } from 'mobx';

export default class OffersAppDelegate extends TransactionAppDelegate {
  constructor(item) {
    super(item);

    makeObservable(this);
  }

  @computed
  get account() {
    return this.item.store.parent.account;
  }

  @computed
  get data() {
    return this.item.typeItem || {};
  }

  @computed
  get offerPackageId() {
    return this.data.offerPackageId;
  }

  @computed
  get keyTermsConfig() {
    return toJS(this.data.keyTermsConfig?.keyTerms || []);
  }

  @computed
  get offerPackage() {
    const offerPackageId = this.offerPackageId;
    return offerPackageId
      ? this.item.store.getItem(
          this.item.transaction.id,
          'TRANSACTION_PACKAGE',
          offerPackageId
        )
      : null;
  }

  @computed
  get submissionPreferences() {
    return this.data.submissionPreferences || {};
  }

  @computed
  get clientWorkspace() {
    return this.data.clientWorkspace || {};
  }

  @computed
  get clientWorkspaceEnabled() {
    return Boolean(this.clientWorkspace.enabled);
  }

  @computed
  get clientsSeen() {
    return this.clientWorkspace.clientsSeen || [];
  }

  getUsersClientSeen = (user) => {
    const userId = (user || this.account.user).id;
    return this.clientsSeen.find((cs) => cs.userId === userId);
  };

  userSeenOffer = (offer, user) => {
    const clientSeen = this.getUsersClientSeen(user);
    return Boolean(
      clientSeen &&
        clientSeen.seenOfferIds
          .map((o) => o.split(':'))
          .find(([id, vers]) => id === offer.id && +vers >= +offer.vers)
    );
  };

  @computed
  get allBoundSellers() {
    return this.item.transaction.parties.sellers.filter(
      (s) => s.isBound && s.email
    );
  }

  @computed
  get sellersWithAccess() {
    if (!this.clientWorkspaceEnabled) {
      return [];
    }

    return this.allBoundSellers;
  }

  @computed
  get userIdsSeen() {
    return Array.from(new Set(this.clientsSeen.map((cs) => cs.userId)));
  }

  @computed
  get sellersSeen() {
    return this.sellersWithAccess.filter((s) =>
      this.userIdsSeen.includes(s.userId)
    );
  }

  @computed
  get countOfUsersSeenNoLongerSellers() {
    const allBoundSellersUserIds = new Set(
      this.allBoundSellers.map((s) => s.userId)
    );
    return this.userIdsSeen.filter((uid) => !allBoundSellersUserIds.has(uid))
      .length;
  }

  @computed
  get offersSummary() {
    return this.data.offersSummary || [];
  }
}
